import { render, staticRenderFns } from "./accOrders.vue?vue&type=template&id=4742333e"
import script from "./accOrders.vue?vue&type=script&lang=js"
export * from "./accOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports